/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Composables
import { createVuetify } from 'vuetify';
import { h } from 'vue';
import themes from '@/themes/defaultTheme';

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes
  },
  icons: {
    defaultSet: 'material-symbols',
    aliases: {
      // checkbox
      checkboxOn: 'check_box',
      checkboxOff: 'check_box_outline_blank',
      checkboxIndeterminate: 'indeterminate_check_box',

      // radio
      radioOn: 'radio_button_checked',
      radioOff: 'radio_button_unchecked',

      // select dropdown
      dropdown: 'arrow_drop_down',

      // clear
      clear: 'close',

      // close
      close: 'close',

      // success / error / warning (optional)
      success: 'check_circle',
      error: 'error',
      warning: 'warning',
      info: 'info'
    },
    sets: {
      'material-symbols': {
        component: (props: any) => {
          const isMdi = props.icon.startsWith('mdi-');
          if (isMdi) {
            return h('i', {
              class: `mdi ${props.icon}`
            });
          }
          return h(
            'span',
            {
              class: 'material-symbols-outlined'
            },
            props.icon
          );
        }
      }
    }
  }
});
